function isBTMDisabled(): boolean {
  return true
}

export default isBTMDisabled
